import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { authReset } from "../../lib/api";
import { formatApiErrorDetail } from "../../context/AuthContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await authReset(token, password);
      toast.success("Your password has been reset. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-black flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white p-8 sm:p-10">
        <h1 className="font-serif text-2xl text-brand-black mb-2">Choose a new password</h1>
        {!token ? (
          <p className="text-sm text-brand-danger" data-testid="reset-no-token">This reset link is invalid. Please request a new one.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-sm font-semibold">New password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
                data-testid="reset-password-input" className="rounded-sm focus-visible:ring-brand-gold" />
            </div>
            {error && <p className="text-sm text-brand-danger" data-testid="reset-error">{error}</p>}
            <Button type="submit" disabled={busy} data-testid="reset-submit-button"
              className="w-full bg-brand-black text-white hover:bg-brand-gold rounded-sm">
              {busy ? "Saving…" : "Reset password"}
            </Button>
          </form>
        )}
        <div className="mt-5 text-center">
          <Link to="/admin/login" className="text-sm text-brand-gold hover:text-brand-black" data-testid="reset-back-link">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
